// TODO refactor code with new variables

.label {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  user-select: none;
  border-radius: var(--radius-size-sm);

  // border-radius: $radius-size-small;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.5;

  &--primary {
    background-color: var(--background-color-secondary);

    // color: $brand-primary-main;
  }

  &--secondary {
    // background-color: $brand-secondary-lightest;
    // color: $brand-secondary-main;
  }

  &--success {
    background-color: var(--color-system-success-light);
    color: var(--color-system-success);
  }

  &--error {
    background-color: var(--color-system-error-light);
    color: var(--color-system-error);
  }
}
